import axios from 'axios';

const API_KEY = '841167fa8e79f7af9bfb5784'; // �滻Ϊ���ʵ�� API Key
const BASE_URL = 'https://v6.exchangerate-api.com/v6';

// LocalStorage ��������
const STORAGE_KEY = 'exchange_rate_usd_cny';
const CACHE_EXPIRY = 12 * 60 * 60 * 1000; // 12Сʱ����ʧЧ

export default {
    /**
     * ��ȡ��Ԫ������һ��ʣ����ȴӻ����ȡ��
     * @returns {Promise<number>} ����ֵ
     */
    async getUSDtoCNY() {
        // 1. ���Դ� LocalStorage ��ȡ����
        const cachedData = this._getCachedRate();
        if (cachedData) return cachedData.rate;

        // 2. ���� API ��ȡ���»���
        try {
            const response = await axios.get(`${BASE_URL}/${API_KEY}/latest/USD`);
            if (response.data.result === 'success') {
                const rate = response.data.conversion_rates.CNY;

                // 3. �洢�� LocalStorage
                this._cacheRate(rate);
                return rate;
            }
            throw new Error('API ���������쳣');
        } catch (error) {
            console.error('��ȡ����ʧ��:', error);
            // 4. �������������ػ���Ĺ������ݻ�Ĭ��ֵ
            return cachedData?.rate || 6.5; // Ĭ��ֵ
        }
    },

    // ˽�з�������ȡ����
    _getCachedRate() {
        const rawData = localStorage.getItem(STORAGE_KEY);
        if (!rawData) return null;

        const { rate, timestamp } = JSON.parse(rawData);
        if (Date.now() - timestamp < CACHE_EXPIRY) {
            return { rate, timestamp };
        }
        return null;
    },

    // ˽�з������洢����
    _cacheRate(rate) {
        const cacheData = {
            rate,
            timestamp: Date.now()
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(cacheData));
    }
};
